@if (content) {
<icms-outlet [components]="content.components"
             [name]="name"
             [allow]="allow"
             [allowOnly]="allowOnly"
             [disallow]="disallow"
             [options]="options" />
}